import { Component } from '@angular/core';
import { MessageType } from '@constants/message/1.0';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { NgIf, NgFor } from '@angular/common';
import { MessageComponent } from '../../message/1.0/message.component';

@Component({
  selector: 'formly-object-type',
  templateUrl: './object-type.component.html',
  styleUrls: ['./object-type.component.scss'],
  standalone: true,
  imports: [NgIf, MessageComponent, FormlyModule, NgFor],
})
export class ObjectTypeComponent extends FieldType {
  messageType = MessageType;
  defaultOptions = {
    defaultValue: {},
  };
}
